'use strict'

/**
 * Project easy title 24
 * Created by hielo on 2018-06-25
 */

import e24Footer from './footer.vue'
import e24NavBar from './nav-bar.vue'
import e24Header from './header.vue'
// import helpButton from './help-button.vue'
import appLink from './app-link.vue'

// Party components
import jnxPersonName from './party/person-name.vue'
import jnxOrgName from './party/org-name.vue'
import jnxAddress from './party/address.vue'
import jnxPersonJob from './party/person-job.vue'
import jnxPhone from './party/phone.vue'
import jnxEmail from './party/email.vue'

// Account components
import jnxUser from './account/user.vue'
import jnxRole from './account/role.vue'

function components (Vue, options) {
	// Other components
	// Vue.component('help-button', helpButton)
	Vue.component('app-link', appLink)

	// Structure
	Vue.component('v-e24-footer', e24Footer)
	Vue.component('v-e24-nav-bar', e24NavBar)
	Vue.component('v-e24-header', e24Header)

	// Janux people components
	Vue.component('v-jnx-person-name', jnxPersonName)
	Vue.component('v-jnx-org-name', jnxOrgName)
	Vue.component('v-jnx-address', jnxAddress)
	Vue.component('v-jnx-person-job', jnxPersonJob)
	Vue.component('v-jnx-phone', jnxPhone)
	Vue.component('v-jnx-email', jnxEmail)

	// Janux account components
	Vue.component('v-jnx-user', jnxUser)
	Vue.component('v-jnx-role', jnxRole)
}

export default components



// WEBPACK FOOTER //
// /var/tomcat/.jenkins/workspace/EasyTitle24/easytitle24-2.x-common/components/index.js